import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { canonicalCityPath } from "@/lib/alias-routes";

/**
 * Links to a city's gold page at its ONE canonical URL.
 *
 * A city is reachable at several paths (/gold-rate-karachi,
 * /pakistan/karachi, /city/pakistan/karachi). Internal links should all point
 * at the same one, so crawlers see a single well-linked document per city
 * instead of the same content spread thinly over three addresses.
 */
export function CityLink({
  country,
  city,
  className,
  children,
}: {
  country: "pakistan" | "india";
  city: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link to={canonicalCityPath(country, city)} className={className}>
      {children}
    </Link>
  );
}
